import { LayoutProvider } from "../common/layout/layout-provider";
import { PageHeader } from "../common/page-header";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { StaffTabContent } from "./staff-tab-content";
import { StaffLevelsTabContent } from "./staff-levels-tab-content";

export function StaffPage() {
  return (
    <div>
      <PageHeader title="Manage Staff" />
      <LayoutProvider>
        <Tabs defaultValue="staff">
          <TabsList className="bg-neutral-50 border-b-2 border-border rounded-none w-full p-0 h-auto justify-start">
            <TabsTrigger
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
              value="staff"
            >
              Staff
            </TabsTrigger>
            <TabsTrigger
              value="levels"
              className="data-[state=active]:border-b-2 data-[state=active]:border-primary data-[state=active]:shadow-none data-[state=active]:font-semibold rounded-none pb-0 mb-[-2px] text-base"
            >
              Levels
            </TabsTrigger>
          </TabsList>
          <TabsContent value="staff">
            <StaffTabContent />
          </TabsContent>
          <TabsContent value="levels">
            <StaffLevelsTabContent />
          </TabsContent>
        </Tabs>
      </LayoutProvider>
    </div>
  );
}
